import favrhoodLogo from '../../Assets/Projects/favrhood_logo1.png';

import ethAppImage from '../../Assets/EthiApp.png';
import mathBuddyImage from '../../Assets/MathBuddy2.png';
import q4VirtueImage from '../../Assets/Q4Virtue.png';
import ageCalcImage from '../../Assets/AgeCalc.png';
import alarmClockImage from '../../Assets/AlarmClock.png';

import physicsImage from '../../Assets/physics.png';
import portalImage from '../../Assets/portal.png';
import portfolio3dImage from '../../Assets/portfolio.png';
import gameAnimImage from '../../Assets/gameAnim.png';
import threeDAnimImage from '../../Assets/threeDAnim.png';

export const LAB_OWNER = {
  choicest: 'choicest',
  interns: 'interns',
};

export const ownerLabels = {
  [LAB_OWNER.choicest]: 'Choicest Fruit',
  [LAB_OWNER.interns]: 'Intern Projects',
};

/**
 * Keep this list simple + editable.
 * Add new projects by appending an item; the page UI will auto-update.
 */
export const labProjects = [
  {
    id: 'favrhood',
    owner: LAB_OWNER.choicest,
    title: 'Favrhood',
    description:
      'A neighborhood innovation hub built by Choicest Fruit—helping communities launch projects, share skills, and collaborate locally.',
    tags: ['Product', 'Community', 'Web App'],
    href: 'https://www.favrhood.com/',
    cta: 'Visit Favrhood',
    image: favrhoodLogo,
    featured: true,
  },

  // Intern web apps
  {
    id: 'ethical-tech-app',
    owner: LAB_OWNER.interns,
    title: 'Ethical Tech App',
    description:
      'Scenario-based app exploring ethical dilemmas in technology and product decisions.',
    tags: ['Web App', 'Ethics'],
    href: 'https://ishanisjm.github.io/EthicalTechApp/',
    cta: 'View Project',
    image: ethAppImage,
  },
  {
    id: 'math-buddy',
    owner: LAB_OWNER.interns,
    title: 'Math Buddy',
    description: 'Practice-friendly math helper built for learners.',
    tags: ['Web App', 'Education'],
    href: 'https://ishanisjm.github.io/mathBuddy/',
    cta: 'View Project',
    image: mathBuddyImage,
  },
  {
    id: 'quest-for-virtue',
    owner: LAB_OWNER.interns,
    title: 'Quest for Virtue',
    description: 'A browser game focused on values, decisions, and exploration.',
    tags: ['Game', 'Web'],
    href: 'https://universaltruth01.github.io/QuestForVirtue/',
    cta: 'View Project',
    image: q4VirtueImage,
  },
  {
    id: 'age-calculator',
    owner: LAB_OWNER.interns,
    title: 'Age Calculator',
    description: 'Quick utility for calculating age and milestones.',
    tags: ['Web App', 'Utility'],
    href: 'https://ellenscales19.github.io/ageCalculator',
    cta: 'View Project',
    image: ageCalcImage,
  },
  {
    id: 'alarm-clock',
    owner: LAB_OWNER.interns,
    title: 'Alarm Clock',
    description: 'A simple alarm clock experience for the browser.',
    tags: ['Web App', 'Utility'],
    href: 'https://nabilkalenga.github.io/Alarm-Clock/',
    cta: 'View Project',
    image: alarmClockImage,
  },

  // Intern portfolios
  {
    id: 'portfolio-ishani',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Ishani Malismitha',
    tags: ['Portfolio'],
    href: 'https://ishanisjm.github.io/myWebsite/',
    cta: 'Open',
  },
  {
    id: 'portfolio-nathalia',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Nathalia Torres',
    tags: ['Portfolio'],
    href: 'https://nathaliat07.github.io/My-website/',
    cta: 'Open',
  },
  {
    id: 'portfolio-javaughn',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Javaughn Lamar',
    tags: ['Portfolio'],
    href: 'https://javaughn-223.github.io/My-website/',
    cta: 'Open',
  },
  {
    id: 'portfolio-emil',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Emil Trevino',
    tags: ['Portfolio'],
    href: 'https://emil-trevino.github.io/myWebsite/',
    cta: 'Open',
  },
  {
    id: 'portfolio-afseen',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Afseen Khandaker',
    tags: ['Portfolio'],
    href: 'https://afseenk.github.io/website/',
    cta: 'Open',
  },
  {
    id: 'portfolio-ellen',
    owner: LAB_OWNER.interns,
    title: 'Personal Portfolio',
    description: 'Ellen Scales',
    tags: ['Portfolio'],
    href: 'https://ellenscales19.github.io/Website/',
    cta: 'Open',
  },

  // 3D Web (intern showcase)
  {
    id: 'threejs-physics',
    owner: LAB_OWNER.interns,
    title: 'Real-Time Animations',
    description: 'Interactive physics + animation experiments for the web.',
    tags: ['3D Web', 'Three.js'],
    href: 'https://aaronenyetu.github.io/physics_threejs_and_rapier/',
    cta: 'View Project',
    image: physicsImage,
  },
  {
    id: 'portal-scene',
    owner: LAB_OWNER.interns,
    title: '3D Portal Scene',
    description: 'A stylized interactive portal environment.',
    tags: ['3D Web', 'Three.js'],
    href: 'https://3d-portal-scene.vercel.app/',
    cta: 'View Project',
    image: portalImage,
  },
  {
    id: 'three-d-portfolio',
    owner: LAB_OWNER.interns,
    title: '3D Portfolio Landing Page',
    description: 'A modern 3D landing page with motion and depth.',
    tags: ['3D Web', 'Portfolio'],
    href: 'https://3d-portfolio-landing-page.vercel.app/',
    cta: 'View Project',
    image: portfolio3dImage,
  },
  {
    id: 'animated-game-asset',
    owner: LAB_OWNER.interns,
    title: '3D Game Assets',
    description: 'Animated assets designed for interactive experiences.',
    tags: ['3D Web', 'Assets'],
    href: 'https://animated-game-asset.vercel.app/',
    cta: 'View Project',
    image: gameAnimImage,
  },
  {
    id: 'satisfying-loop',
    owner: LAB_OWNER.interns,
    title: '3D Physics Loops',
    description: 'Looping motion studies and satisfying physics timing.',
    tags: ['3D Web', 'Animation'],
    href: 'https://satisfying-loop-threejs.vercel.app/',
    cta: 'View Project',
    image: threeDAnimImage,
  },
];

export const featuredLabProject = labProjects.find((p) => p.featured) ?? labProjects[0];
